// @flow
import * as React from 'react';
import styled from 'styled-components';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import IconButton from 'common/components/ui/IconButton';

interface HeaderProps {
  className: string;
  classNames: Object;
  dir: string;
  labels: Object;
  locale: string;
  localeUtils: Object;
  month: Date;
  nextMonth: Date;
  onNextClick: () => void;
  onPreviousClick: () => void;
  previousMonth: Date;
  showNextButton: boolean;
  showPreviousButton: boolean;
}

const Month = styled.span`
  text-transform: capitalize;
`;

const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${props => props.theme.V3.metrics.margin.small}px;
`;

export default function DatePickerHeader(props: HeaderProps) {
  return (
    <FlexRow>
      <IconButton onClick={props.onPreviousClick} disabled={!props.showPreviousButton}>
        <KeyboardArrowLeft />
      </IconButton>
      <Month>{props.localeUtils.formatMonthTitle(props.month, props.locale)}</Month>
      <IconButton onClick={props.onNextClick} disabled={!props.showNextButton}>
        <KeyboardArrowRight />
      </IconButton>
    </FlexRow>
  );
}



// WEBPACK FOOTER //
// ./src/common/components/ui/datePicker/inner/DatePickerHeader.js